'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonFns = exports.createTextButton = exports.createLargeTextButton = exports.createXlargeSolidIconButton = exports.createLargeSolidIconButton = exports.createSolidIconButton = exports.createLargeIconButton = exports.createIconButton = exports.createLargeGhostButton = exports.createGhostButton = exports.createSquareSolidButton = exports.createLargeSquareSolidButton = exports.createSolidButton = exports.createLargeSolidButton = undefined;

var _glamor = require('@headspace/glamor');

var _colors = require('./colors');

var colors = _interopRequireWildcard(_colors);

var _font = require('./font');

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // compose button


var transition = 'all .2s ease-in-out';
var transform = 'scale(1)';
var comet = colors.comet,
    white = colors.white,
    merino = colors.merino,
    pampas = colors.pampas,
    froly = colors.froly,
    danube = colors.danube,
    tundora = colors.tundora,
    geraldine = colors.geraldine;

var composeButton = function composeButton(font, createColor, createHoverColor) {
  return function (styles) {
    return function () {
      var primaryColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : comet;
      var secondaryColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : white;
      return (0, _glamor.css)(font, (0, _objectAssign2.default)({
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        cursor: 'pointer',
        border: 0,
        transition: transition
      }, createColor(primaryColor, secondaryColor), {
        ':hover': createHoverColor(primaryColor, secondaryColor)
      }, styles));
    };
  };
};

var createSolidButtonColor = function createSolidButtonColor(backgroundColor, color) {
  return {
    backgroundColor: backgroundColor,
    color: color,
    fill: color
  };
};

var createSolidButtonHoverColor = function createSolidButtonHoverColor(backgroundColor, color) {
  return {
    backgroundColor: colors.isDark(backgroundColor) ? colors.darken(backgroundColor, 0.1) : colors.lighten(backgroundColor, 0.01),
    color: color,
    fill: color,
    transform: transform
  };
};

var createGhostButtonColor = function createGhostButtonColor(color) {
  return {
    color: color,
    border: '2px solid ' + color,
    fill: color,
    backgroundColor: 'transparent'
  };
};

var createGhostButtonHoverColor = function createGhostButtonHoverColor(backgroundColor, color) {
  return {
    color: color,
    border: '2px solid ' + backgroundColor,
    backgroundColor: backgroundColor,
    fill: color,
    transform: transform
  };
};

var createTextButtonColor = function createTextButtonColor(color) {
  return {
    color: color,
    fill: color,
    backgroundColor: 'transparent'
  };
};

var createTextButtonColorHover = function createTextButtonColorHover(color) {
  return {
    color: colors.rgba(color, 0.8),
    fill: colors.rgba(color, 0.8),
    backgroundColor: 'transparent'
  };
};

var solidButtonBase = [_font.utility3, createSolidButtonColor, createSolidButtonHoverColor];
var ghostButtonBase = [_font.utility3, createGhostButtonColor, createGhostButtonHoverColor];
var textButtonBase = [_font.utility3, createTextButtonColor, createTextButtonColorHover];
var createLargeSolidButton = exports.createLargeSolidButton = composeButton.apply(undefined, solidButtonBase)({
  borderRadius: 28,
  height: 56,
  paddingLeft: 32,
  paddingRight: 32
});
var createSolidButton = exports.createSolidButton = composeButton.apply(undefined, solidButtonBase)({
  borderRadius: 20,
  height: 40,
  paddingLeft: 32,
  paddingRight: 32
});
var createLargeSquareSolidButton = exports.createLargeSquareSolidButton = composeButton.apply(undefined, solidButtonBase)({
  borderRadius: 4,
  height: 80,
  paddingLeft: 86,
  paddingRight: 86
});
var createSquareSolidButton = exports.createSquareSolidButton = composeButton.apply(undefined, solidButtonBase)({
  borderRadius: 4,
  height: 56,
  paddingLeft: 65,
  paddingRight: 65
});

var _createGhostButton = composeButton.apply(undefined, ghostButtonBase)({
  borderRadius: 20,
  height: 40,
  paddingLeft: 30,
  paddingRight: 30
});

exports.createGhostButton = _createGhostButton;
var createLargeGhostButton = exports.createLargeGhostButton = composeButton.apply(undefined, ghostButtonBase)({
  borderRadius: 28,
  height: 56,
  paddingLeft: 30,
  paddingRight: 30
});

var _createIconButton = composeButton.apply(undefined, ghostButtonBase)({
  borderRadius: 20,
  height: 40,
  width: 40
});

exports.createIconButton = _createIconButton;
var createLargeIconButton = exports.createLargeIconButton = composeButton.apply(undefined, ghostButtonBase)({
  borderRadius: 28,
  height: 56,
  width: 56
});
var createSolidIconButton = exports.createSolidIconButton = composeButton.apply(undefined, solidButtonBase)({
  borderRadius: 20,
  height: 40,
  width: 40
});
var createLargeSolidIconButton = exports.createLargeSolidIconButton = composeButton.apply(undefined, solidButtonBase)({
  borderRadius: 28,
  height: 56,
  width: 56
});
var createXlargeSolidIconButton = exports.createXlargeSolidIconButton = composeButton.apply(undefined, solidButtonBase)({
  borderRadius: 40,
  height: 80,
  width: 80
});
var createLargeTextButton = exports.createLargeTextButton = composeButton.apply(undefined, textButtonBase)({
  height: 56,
  paddingLeft: 32,
  paddingRight: 32
});

var _createTextButton = composeButton.apply(undefined, textButtonBase)({
  height: 40,
  paddingLeft: 32,
  paddingRight: 32
});

exports.createTextButton = _createTextButton;
var buttonFns = exports.buttonFns = {
  createSmallGhostButton: _createGhostButton,
  createGhostButton: function createGhostButton(primary, secondary) {
    return (0, _glamor.css)(_createGhostButton(primary, secondary), _defineProperty({}, '@media (min-width: ' + _breakpoints2.default.l + 'px)', createLargeGhostButton(primary, secondary)));
  },
  createSmallSquareButton: createSquareSolidButton,
  createSquareButton: function createSquareButton(primary, secondary) {
    return (0, _glamor.css)(createSquareSolidButton(primary, secondary), _defineProperty({}, '@media (min-width: ' + _breakpoints2.default.l + 'px)', createSquareSolidButton(primary, secondary)));
  },
  createLargeSquareButton: function createLargeSquareButton(primary, secondary) {
    return (0, _glamor.css)(createLargeSquareSolidButton(primary, secondary), _defineProperty({}, '@media (min-width: ' + _breakpoints2.default.l + 'px)', createLargeSquareSolidButton(primary, secondary)));
  },
  createSmallRoundButton: createSolidButton,
  createRoundButton: function createRoundButton(primary, secondary) {
    return (0, _glamor.css)(createSolidButton(primary, secondary), _defineProperty({}, '@media (min-width: ' + _breakpoints2.default.l + 'px)', createLargeSolidButton(primary, secondary)));
  },
  createSmallIconButton: _createIconButton,
  createIconButton: function createIconButton(primary, secondary) {
    return (0, _glamor.css)(_createIconButton(primary, secondary), _defineProperty({}, '@media (min-width: ' + _breakpoints2.default.l + 'px)', createLargeIconButton(primary, secondary)));
  },
  createSmallIconSolidButton: createSolidIconButton,
  createIconSolidButton: function createIconSolidButton(primary, secondary) {
    return (0, _glamor.css)(createSolidIconButton(primary, secondary), _defineProperty({}, '@media (min-width: ' + _breakpoints2.default.l + 'px)', createLargeSolidIconButton(primary, secondary)));
  },
  createXlargeIconSolidButton: function createXlargeIconSolidButton(primary, secondary) {
    return (0, _glamor.css)(createSolidIconButton(primary, secondary), _defineProperty({}, '@media (min-width: ' + _breakpoints2.default.l + 'px)', createXlargeSolidIconButton(primary, secondary)));
  },
  createSmallTextButton: _createTextButton,
  createTextButton: function createTextButton(primary) {
    return (0, _glamor.css)(_createTextButton(primary), _defineProperty({}, '@media (min-width: ' + _breakpoints2.default.l + 'px)', createLargeTextButton(primary)));
  }
}; // TODO: deprecate?

exports.default = {
  cometButton: buttonFns.createRoundButton(),
  cometGhostButton: buttonFns.createGhostButton(),
  cometGhostIconCircleButton: buttonFns.createIconButton(),
  cometButtonSquare: buttonFns.createSquareButton(),
  cometIconButton: buttonFns.createIconSolidButton(),
  cometTextButton: buttonFns.createTextButton(),
  danubeButtonSquare: buttonFns.createSquareButton(danube, white),
  frolyButtonSquare: buttonFns.createSquareButton(froly, white),
  geraldineButtonSquare: buttonFns.createSquareButton(geraldine, white),
  merinoButtonSquare: buttonFns.createSquareButton(merino, comet),
  pampasButtonSquare: buttonFns.createSquareButton(pampas, comet),
  pampasIconButton: buttonFns.createIconButton(pampas, comet),
  pampasIconButtonSmall: buttonFns.createSmallIconButton(pampas, comet),
  pampasButton: buttonFns.createRoundButton(pampas, comet),
  tundoraIconButtonSmall: buttonFns.createSmallIconButton(tundora, white),
  whiteIconButtonXlarge: buttonFns.createXlargeIconSolidButton(white, comet),
  whiteGhostButton: buttonFns.createGhostButton(white, comet),
  whiteButton: buttonFns.createRoundButton(white, comet)
};